import { productIdFormat } from "@redotech/redo-model/ids";
import { barcodeLabelSize } from "@redotech/redo-model/inventory/barcode-label";
import * as z from "zod/v4";

export const generateBarcodeLabel = {
  name: "generateBarcodeLabel" as const,
  input: z.object({
    barcodeValue: z.string().min(1).optional(),
    sku: z.string().optional(),
    productTitle: z.string().optional(),
    labelSize: z.enum(barcodeLabelSize).optional(),
    showSku: z.boolean().optional(),
    showTitle: z.boolean().optional(),
    showPrice: z.boolean().optional(),
    price: z.string().optional(),
    productIds: z.array(productIdFormat.schema).optional(),
  }),
  output: z.object({ pdfBase64: z.string() }),
};
